import { render, staticRenderFns } from "./custom-lectures-dialog.vue?vue&type=template&id=07e39de6"
import script from "./custom-lectures-dialog.vue?vue&type=script&lang=ts"
export * from "./custom-lectures-dialog.vue?vue&type=script&lang=ts"
import style0 from "./custom-lectures-dialog.vue?vue&type=style&index=0&id=07e39de6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports